import React, { useCallback, useRef } from "react";
import "./ConditionSearch.less";
import IconFont from "@/components/icon";
import { Checkbox } from "antd";
import { SearchGlobalContext } from "./utils";
import TypeSelect from "@/components/Work/BaseComponents/TypeSelect";
import { timeList, timeSlot } from "./ConditionSearch";
import { scheduleTypeList } from "@/components/Calendars/ScheduleTypeSelect";

export function ConditionSearchScheduleItem({
  t,
  onClose,
  setScheduleColor,
  ConditionVisible,
  setScheduleDeadlineTime
}: {
  t: any;
  ConditionVisible: boolean;
  onClose: Function;
  setScheduleColor: Function;
  setScheduleDeadlineTime: Function;
}) {
  const { scheduleDeadlineTime, scheduleColor } = React.useContext(SearchGlobalContext);
  const childRef:any = useRef(null);

  // 清除操作
  const handleClear = useCallback(
    (type) => {
      switch (type) {
        case "clearAll":
          setScheduleDeadlineTime(undefined);
          setScheduleColor([]);
          childRef.current?.resetAllSelectStatus();
          break;
        case "scheduleDeadlineTime":
          setScheduleDeadlineTime(undefined);
          break;
        case "scheduleColor":
          setScheduleColor([]);
          childRef.current?.resetAllSelectStatus();
          break;
        default:
          break;
      }
    },
    [setScheduleDeadlineTime, setScheduleColor]
  );

  return (
    <div className="ConditionSearchItem">
      <div className="SearchItem_type">
        <header>
          <h3 className={`${scheduleColor?.length || scheduleDeadlineTime ? "Highlight" : ""}`}>
            <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
            {scheduleColor?.length || scheduleDeadlineTime
              ? "已启用筛选"
              : t("Condition.conditional filtering")}
          </h3>
          <div className="onClear">
            {(!!scheduleColor?.length || scheduleDeadlineTime) && (
              <>
                <span
                  className="text"
                  onClick={() => {
                    handleClear("clearAll");
                  }}
                >
                  {t("Condition.clearAll")}
                </span>
                <div className="line" />
              </>
            )}
            <IconFont
              type="iconic_pc_im_deletee"
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </header>
        <div className="SearchItem_title">
          <h4>{t("Condition.deadline time")}</h4>
          {scheduleDeadlineTime && (
            <span
              className="del"
              onClick={() => {
                handleClear("scheduleDeadlineTime");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <div className="SearchItem_deadlineTime_list_item">
          {timeList?.map((item: { label: string; value: timeSlot }, index: number) => (
            <Checkbox
              className={index % 2 === 0 ? "even" : "odd"}
              key={"deadlineTime-" + index}
              value={item.value}
              checked={item.value === scheduleDeadlineTime}
              onChange={(e: any) => {
                if (e?.target?.value === scheduleDeadlineTime) {
                  setScheduleDeadlineTime(undefined);
                } else {
                  setScheduleDeadlineTime(e?.target?.value);
                }
              }}
            >
              {item.label}
            </Checkbox>
          ))}
        </div>
        <div className="SearchItem_title">
          <h4>{t("Condition.type")}</h4>
          {!!scheduleColor?.length && (
            <span
              className="del"
              onClick={() => {
                handleClear("scheduleColor");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <div className="SearchItem_type_item">
          <TypeSelect
            ref={childRef}
            defaultChecked={scheduleColor?.map(
              (color: string) =>
                scheduleTypeList.length -
                scheduleTypeList.findIndex(
                  (type) => type.color?.toUpperCase() === color?.toUpperCase()
                )
            )}
            defaultAllChecked={false}
            onCheckboxChange={(num: number[]) => {
              setScheduleColor(
                num?.map((v) => scheduleTypeList[scheduleTypeList.length - v].color)
              );
            }}
            type="checkbox"
            isCreate={true}
          />
        </div>
      </div>
    </div>
  );
}
